var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.205h-8.53c-2.551 0-4.265 1.714-4.265 4.265v17.733c0 0.842 0.314 3.592 4.357 3.592h21.233v-25.59h-12.795zM14.934 4.271v10.2l-2.611-2.378-2.899 2.44v-10.261h5.511zM7.47 4.271h0.887v12.552l3.938-3.313 3.706 3.374v-12.613h11.729v17.593h-20.259c-1.357 0-2.457 0.405-3.199 1.113v-15.508c0-1.943 1.256-3.199 3.199-3.199zM7.562 27.729c-2.444 0-3.151-1.109-3.269-2.17 0.002-1.646 1.189-2.628 3.177-2.628h20.259v4.798h-20.167z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.4b3ecbf82522a86fec326fd82b3cdf8c.svg";
export { ForwardRef as ReactComponent };